import {DroppableId} from '../../../../../lib/components/drag-n-drop';
import {objectPatch} from '../../../../../lib/helpers';
import {GroupingExerciseState, GroupState, ItemPosition, ItemState, ItemStates} from './models';

export function itemIdFromPosition(itemId: ItemPosition) {
  return itemId.group.toString(10) + '/' + itemId.index.toString(10);
}

export function itemIdToPosition(itemId: string): ItemPosition {
  let split = itemId.split('/');
  return {
    group: parseInt(split[0], 10),
    index: parseInt(split[1], 10)
  };
}

export function indexToDroppableId(groupIndex: number): DroppableId {
  return groupIndex.toString(10);
}

export const ungroupedDroppableId = 'draggables';

export function indexFromDroppableId(droppableId: DroppableId | null): number | null {
  if (droppableId === null || droppableId === ungroupedDroppableId)
    return null;
  return parseInt(droppableId, 10);
}

/******************************************************************************/

function _resetItemChecked(state: GroupingExerciseState,
                           itemId: string): ItemStates {
  const item = state.items[itemId];
  if (!item.checked)
    return state.items;
  const newState = {checkCount: item.checkCount, checked: false};
  return objectPatch(state.items, itemId, newState);
}

function _removeItemFromGroups(state: GroupingExerciseState,
                               itemId: string): readonly string[][] {
  const groupStates: string[][] = [];
  for (let group of state.groups)
    groupStates.push(group.filter(id => id !== itemId));
  return groupStates;
}

function _addItemToGroup(state: GroupingExerciseState,
                         itemId: string,
                         groupId: string | null): readonly GroupState[] {
  const groups = _removeItemFromGroups(state, itemId).slice();

  const groupIndex = indexFromDroppableId(groupId);
  if (groupIndex === null)
    return groups;

  groups[groupIndex].push(itemId);
  return groups;
}

export function addItemToGroup(state: GroupingExerciseState,
                               itemId: string,
                               groupId: string | null): GroupingExerciseState {
  return {
    itemOrder: state.itemOrder,
    groups: _addItemToGroup(state, itemId, groupId),
    items: _resetItemChecked(state, itemId)
  };
}

export function checkAllItems(state: GroupingExerciseState): GroupingExerciseState {
  const items: { [index: string]: ItemState } = {};
  for (let [itemId, item] of Object.entries(state.items)) {
    if (item.checked)
      items[itemId] = item;
    else
      items[itemId] = {checked: true, checkCount: item.checkCount + 1};

  }

  return {
    itemOrder: state.itemOrder,
    items: items,
    groups: state.groups
  };
}
